module.exports = __webpack_public_path__ + "fd1f162ea55381b2145a3ab44bee05c7.jpg";